import { useMemo, useEffect, useState } from "react";

const useAudio = (url) => {
  const audio = useMemo(() => new Audio(url), []);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    setPlaying((prevProps) => !prevProps);
  };

  useEffect(() => {
    const setPlaying = async () => {
      try {
        if (playing) {
          await audio.play();
        } else {
          await audio.pause();
        }
      } catch (err) {
        console.log("Error: ", err);
      }
    };
    setPlaying();
  }, [playing]);

  useEffect(() => {
    audio.addEventListener("ended", () => setPlaying(false));
    return () => {
      audio.removeEventListener("ended", () => setPlaying(false));
    };
  }, []);

  return [playing, toggle];
};

export default useAudio;
